/*
  Plainpad - Self Hosted Note Taking App

  Copyright (C) 2020 Alex Tselegidis - https://alextselegidis.com

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU General Public License for more details.

  You should have received a copy of the GNU General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>
*/

export default {
  settings: 'Einstellungen',
  setting: 'Einstellunge',
  defaultLocale: 'Standard-Sprachumgebung',
  mail: 'Mail',
  driver: 'Treiber',
  host: 'Host',
  port: 'Port',
  username: 'Username',
  password: 'Passwort',
  encryption: 'Verschlüsselung',
  fromAddress: 'Von Adresse',
  fromName: 'Von Name',
  save: 'speichern',
  saveSuccess: 'Einstellungen erfolgreich gespeichert.',
  saveFailure: 'Einstellungen konnten nicht gespeichert werden.',
  fetchFailure: 'Einstellungen konnten nicht abgerufen werden.',
  updates: 'Updates',
  update: 'Update',
  newUpdatesAvailable: 'Es sind neue Updates zum Herunterladen verfügbar.',
  beforeUpdatingMakeSure: 'Vor dem Update, stell dich sicher, dass das Plainpad-Installationsverzeichnis durch den PHP-Prozess beschreibbar ist. Falls das Update mit einem Fehler endet, musst du eventuell manuell den Befehl "php artisan refresh" vom Terminal aus ausführen, um den Prozess abzuschließen.',
}
